import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Store from "../store";

axios.interceptors.request.use(
  async config => {
    if (config.method !== "get") {
      let token = Store.getters.getCsrfToken;
      if (!token) {
        await Store.dispatch("fetchCsrfToken");
        token = Store.getters.getCsrfToken;
      }
      config.headers["X-CSRF-TOKEN"] = token;
    }
    return config;
  },
  error => Promise.reject(error)
);

Vue.use(VueAxios, axios);
